<template>
  <form
    class="sm-form sm-form__edit-additional"
    @submit.prevent="handleSubmit"
  >
    <h4>Update recipient</h4>
    <input-text
      v-model="formData.first_name"
      :name="'first_name'"
      :label="'First name'"
      :data-vv-as="'First name'"
      v-validate="'required'"
      :error="errors.first(`first_name`)"
    />
    <input-text
      v-model="formData.last_name"
      :name="`last_name`"
      :label="'Last name'"
      :data-vv-as="'Last name'"
      v-validate="'required'"
      :error="errors.first(`last_name`)"
    />
    <div class="sm-form__edit-additional-flex">
      <btn-block
        :type="'reset'"
        :text="'Cancel'"
        :class="'sm-btn--small sm-btn--grey'"
        @click="$emit('reset')"
      />
      <btn-block
        :type="'submit'"
        :text="'Update'"
        :class="'sm-btn--small'"
      />
    </div>
  </form>
</template>

<script>
import InputText from '@/components/InputText';

export default {
  name: 'form-edit-additional',
  components: {
    'input-text': InputText
  },
  props: {
    startVal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        id: null,
        first_name: '',
        last_name: ''
      }
    }
  },
  created() {
    Object.keys(this.formData).forEach(key => {
      if (this.startVal[key])
        this.formData[key] = this.startVal[key];
    })
  },
  methods: {
    handleSubmit() {
      this.$validator.validate()
        .then(valid => {
          if (!valid)
            return;

          this.$emit('submit', this.formData);
        })
    }
  }
}
</script>